"use client";

import dynamic from "next/dynamic";

export const ModalClient = dynamic(
  async () => (await import("@/src/components/ui/Modal/Modal")).Modal,
  { ssr: false },
);
